import React, { FC } from 'react';
import { VideoProps } from '../../atoms/Video';
import { ActionButtonProps } from '../../atoms/ActionButton';
import { HtmlProps } from '../../atoms/Html';
import { PictureProps } from '../../atoms/Picture';
import * as SC from './styled';
export type ArticleBlockProps = MinimalSeoBlock & {
  title?: string;
  anchor?: string;
  htmlProps?: HtmlProps;
  pictureProps?: PictureProps;
  mobilePictureProps?: PictureProps;
  buttons?: ActionButtonProps[];
  videoProps?: VideoProps;
};
const ArticleBlock: FC<ArticleBlockProps> = ({
  htmlTag,
  htmlTitleTag,
  title,
  anchor,
  htmlProps,
  pictureProps,
  mobilePictureProps,
  buttons,
  videoProps
}) => {
  return <SC.ArticleBlock as={htmlTag}>
      <SC.Content>
        {title && <SC.Title id={anchor} as={htmlTitleTag}>
            {title}
          </SC.Title>}
        {!mobilePictureProps && pictureProps && <SC.StyledPicture {...pictureProps} />}
        {mobilePictureProps && pictureProps && <>
            <SC.DesktopStyledPicture {...pictureProps} />
            <SC.MobileStyledPicture {...mobilePictureProps} />
          </>}
        {videoProps && <SC.StyledVideo {...videoProps} />}
        {htmlProps && <SC.Text {...htmlProps} />}
      </SC.Content>
      {buttons && buttons.length > 0 && <SC.Buttons>
          {buttons.map((button, index) => <SC.Button {...button} key={index} />)}
        </SC.Buttons>}
    </SC.ArticleBlock>;
};
export default ArticleBlock;